import axios from "axios";
import { notificationHandler } from "reducers/notificationSlice";
import { URL } from "./MainAPILink";
import CatchMessage from "./catchMessage";
import { notify } from "App";

const GetAllDevoteeDataAPI = async (access_token, page_no, page_size, search) => {
  try {
    const response = await axios.get(URL + "devotee", {
      params: {
        page_no,
        page_size,
        search,
      },
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);

    return (
      err.response?.data || {
        is_success: false,
        message: err.message || "Unable to fetch devotee data",
        data: null,
      }
    );
  }
};
const AddDevoteeAPI = async (data, access_token) => {
  try {
    const response = await axios.post(URL + "devotee", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err?.response?.message, "error");

    return err.response.data;
  }
};

const AddAddressAPI = async (data, access_token) => {
  try {
    const response = await axios.post(URL + "devotee/address", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);

    notify(err?.response?.message, "error");

    return err.response.data;
  }
};
const GetDevoteeDataAPI = async (devotee_id, access_token) => {
  try {
    const response = await axios.get(URL + "devotee?devotee_id=" + devotee_id, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return response.data;
  } catch (err) {
    CatchMessage(err);

    return err.response.data;
  }
};
const GetDevoteeAddressAPI = async (devotee_id, access_token) => {
  try {
    const ReqUrl = URL + "devotee/address?devotee_id=" + devotee_id;
    const response = await axios.get(ReqUrl, {
      headers: { Authorization: `Bearer ${access_token}` },
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);
    return err.response.data;
  }
};

const EditDevoteDataAPI = async (data, access_token) => {
  try {
    const response = await axios.put(URL + "devotee", data, {
      headers: { Authorization: `Bearer ${access_token}` },
      "Content-Type": "application/json",
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err?.response?.message, "error");
    return err.response.data;
  }
};
const EditDevoteeAddressAPI = async (data, access_token) => {
  try {
    const response = await axios.put(URL + "devotee/address", data, {
      headers: { Authorization: `Bearer ${access_token}` },
      "Content-Type": "application/json",
    });

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err?.response?.message, "error");

    return err.response.data;
  }
};

const UploadDevoteeImageAPI = async (data, access_token) => {
  try {
    const response = await axios.post(URL + "devotee/picture", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    notify("Devotee image uploaded successfully", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err?.response?.message, "error");

    return err.response.data;
  }
};

const DeleteAddressAPI = async (data, access_token) => {
  try {
    const response = await axios.delete(URL + "devotee/address", {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      data: {
        devotee_address_id: `${data}`,
      },
    });
    notify("Devotee Address deleted", "success");
    return response.data;
  } catch (err) {
    CatchMessage(err);
    notify(err?.response?.message, "error");
    return err.response.data;
  }
};
const DeleteDevoteeAPI = async (devotee_id, access_token, dispatch) => {
  try {
    const response = await axios.delete(URL + "devotee/admin", {
      params: { devotee_id },
      headers: { Authorization: `Bearer ${access_token}` },
    });
    notify(response.data?.message || "Devotee deleted !", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err, dispatch);
    notify(err?.response?.data?.message || "Could not delete devotee", "error");

    return null;
  }
};
const ActiveDevoteeAPI = async (devotee_id, access_token, dispatch) => {
  try {
    const response = await axios.post(
      URL + "devotee/active_devotee",
      { devotee_id },
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
    notify(response.data?.message || "Devotee activated", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err, dispatch);
    notify(err?.response?.data?.message || "Could not activate devotee", "error");

    return null;
  }
};
const FindDevoteeAPI = async (text, page_no, access_token) => {
  try {
    const response = await axios.get(URL + "devotee/find", {
      params: { text, page_no },
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return response.data;
  } catch (err) {
    CatchMessage(err);
    return (
      err.response?.data || {
        is_success: false,
        message: err.message || "Unable to search devotee",
        data: null,
      }
    );
  }
};

export {
  FindDevoteeAPI,
  AddDevoteeAPI,
  DeleteAddressAPI,
  AddAddressAPI,
  GetDevoteeAddressAPI,
  GetDevoteeDataAPI,
  UploadDevoteeImageAPI,
  EditDevoteDataAPI,
  GetAllDevoteeDataAPI,
  EditDevoteeAddressAPI,
  DeleteDevoteeAPI,
  ActiveDevoteeAPI,
};
